import useFetchResource from 'hooks/useFetchResource';
import api from 'libs/api';
import { selectSerializer } from 'libs/serializers';

export interface ISpot {
  id: number;
  title: string;
  location: string;
}

export function useSpots(initialParams = {}, initialLoad = true) {
  const { resource: spots, fetchResource: fetchSpots } = useFetchResource<ISpot[]>({
    api: api.account.parking.public.spots.getAll,
    initialValues: [],
    initialParams,
    initialLoad,
    serializer: (data) => selectSerializer(data.resources, { labelKey: 'title', valueKey: 'id' }),
  });

  return { spots, fetchSpots };
}
